import { render, staticRenderFns } from "./MenuItemCard.vue?vue&type=template&id=444c738c&"
import script from "./MenuItemCard.vue?vue&type=script&lang=js&"
export * from "./MenuItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports